import React from "react";
import Container from "@material-ui/core/Container";
import Section from "./Section";
import SectionHeader from "./SectionHeader";
import VideoGenerator from "./VideoGenerator";
import ModeTabs from "./ModeTabs";

function VideoGeneratorSection(props) {
  return (
    <Section
      bgColor={props.bgColor}
      size={props.size}
      bgImage={props.bgImage}
      bgImageOpacity={props.bgImageOpacity}
    >
      <Container maxWidth="lg">
        <ModeTabs />
        <SectionHeader
          title={props.title}
          subtitle={props.subtitle}
          size={1}
          textAlign="center"
        />
        <VideoGenerator buttonAction={props.buttonAction} />
      </Container>
    </Section>
  );
}

export default VideoGeneratorSection;
